import { Check } from 'lucide-react';

/** The quiet status that replaces a form's Save once a save succeeded and nothing is left to save. Not a button. */
export function SavedStatus() {
  return (
    <span role="status" className="inline-flex items-center gap-1 text-xs text-text-secondary">
      <Check className="size-4" aria-hidden />
      Changes saved
    </span>
  );
}
